// @flow
import {
  CategoryScale, Chart as ChartJS, Filler, Legend, LinearScale, LineElement, PointElement, Title, Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import moment from 'moment';

ChartJS.register(Filler, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

type Point = { periodStart?: any; averageScore: number };

// Line chart for a score / fail-rate trend (one point per ISO week).
export const QaTrendChart = ({ points, color = '#1C434F', height = 200, fill = false }: {
  points: Point[];
  color?: string;
  height?: number;
  fill?: boolean;
}) => {
  const labels = points.map(p => p.periodStart ? moment(p.periodStart).format('MMM D') : '');
  const data = {
    labels,
    datasets: [{
      data: points.map(p => p.averageScore),
      borderColor: color,
      backgroundColor: fill ? `${color}22` : color,
      fill,
      tension: 0.3,
      pointRadius: 3,
      pointBackgroundColor: '#fff',
      pointBorderColor: color,
      borderWidth: 2,
    }],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: false }, tooltip: { intersect: false, mode: 'index' as const } },
    scales: {
      x: { grid: { display: false } },
      y: { beginAtZero: false, suggestedMin: 40, suggestedMax: 100, ticks: { stepSize: 20 } },
    },
  };
  // position:relative + width:100% keeps chart.js (responsive, no aspect ratio) from
  // growing unbounded and pushing page width past the viewport.
  return <div style={{ height, width: '100%', position: 'relative' }}><Line data={data} options={options} /></div>;
};